import React, { useState } from 'react';
import PropTypes from 'prop-types';

import DatePresenter from '../../../../presenters/DatePresenter';
import { LOCATIONS } from '../../../../presenters/TransactionPresenter';
import StorePresenter from '../../../../presenters/StorePresenter';
import Flash from '../../../../components/forms/Flash';
import Row from '../../../../components/Row';
import Column from '../../../../components/Column';
import Checkbox from '../../../../components/Checkbox';
import RangePicker from '../../../../components/RangePicker';
import StoreSelect from '../../../../components/StoreSelect';

import AdditionalFitlers from './components/AdditionalFilters';

const Form = (props) => {
  const {
    values,
    handleSubmit,
    setFieldValue,
    errors,
    stores,
    storesLoadingState,
  } = props;
  const [showMoreFilters, setShowMoreFilters] = useState(false);
  const toggleShowMoreFilters = () => setShowMoreFilters(!showMoreFilters);
  const handleChange = ({ target: { id, value } }) => {
    setFieldValue(id, value);
  };

  const handleChangeCheckbox = ({ target: { id, checked } }) => {
    setFieldValue(id, checked);
  };

  const handleStartDateChange = (date) => {
    setFieldValue('afterDate', DatePresenter.shortFormattedDate(date));
  };
  const handleEndDateChange = (date) => {
    setFieldValue('beforeDate', DatePresenter.shortFormattedDate(date));
  };

  const buttonText = showMoreFilters ? 'Show less' : 'Show more';

  return (
    <form onSubmit={handleSubmit}>
      <div className="transactions-filters">
        <div className="form-header">
          <h4>Filters</h4>
          <div className="form-header-actions">
            <input
              id="findTransactions"
              type="submit"
              value="Find"
              className="find-button"
            />
          </div>
        </div>
        <Flash response={errors} />
        <Row className="transactions-filters">
          <RangePicker
            startDate={values.afterDate}
            endDate={values.beforeDate}
            onStartDateChange={handleStartDateChange}
            onEndDateChange={handleEndDateChange}
          />
          <Column>
            <StoreSelect
              stores={stores}
              onChange={handleChange}
              value={values.storeIdEq}
              loadingState={storesLoadingState}
            />
          </Column>
          <Column>
            <select
              id="byLocation"
              value={values.byLocation}
              onChange={handleChange}
              className="input-underlined"
            >
              <option value={LOCATIONS.all}>All Locations</option>
              <option value={LOCATIONS.inMall}>In mall</option>
              <option value={LOCATIONS.outOfMall}>Outside mall</option>
            </select>
          </Column>
          <Column>
            <Checkbox
              id="withCashbacks"
              onChange={handleChangeCheckbox}
              checked={values.withCashbacks}
              labelText="Only with FastCash"
              className="label-light"
            />
          </Column>
          <Column>
            <Checkbox
              id="onlyOriginals"
              onChange={handleChangeCheckbox}
              checked={values.onlyOriginals}
              labelText="Only original transactions"
              className="label-light"
            />
          </Column>
        </Row>
        {showMoreFilters && (
          <AdditionalFitlers values={values} onChange={handleChange} />
        )}
        <div>
          <button
            type="button"
            className="action-button show-more-button"
            onClick={toggleShowMoreFilters}
          >
            {buttonText}
          </button>
        </div>
      </div>
    </form>
  );
};

export default Form;

Form.propTypes = {
  values: PropTypes.shape().isRequired,
  handleSubmit: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  errors: PropTypes.shape(),
  stores: PropTypes.arrayOf(StorePresenter.shape()),
  storesLoadingState: PropTypes.string.isRequired,
};

Form.defaultProps = {
  stores: null,
  errors: {},
};
